import React from "react";
import autoBind from "react-autobind";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import noty from "../../lib/noty";
import Field from "../Field";
import {MarkerTypeRecord} from "../../feathers/records";

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
export default class MarkerCategoryModal extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      loaded: false,
      canDelete: true,
      fetching: false,
      touched: false,
      markerCategory: this.props.markerCategory
    };
  }

  // Ensure there are no markerTypes with this category
  // Do not let the user delete if so.
  // TODO: This could be improved to show the number and
  // names of related markerTypes.
  async componentDidMount() {
    const {markerCategory} = this.props;
    const {total} = await MarkerTypeRecord.find({
      query: {
        category_id: markerCategory._id,
        $limit: 0
      },
      skipHooks: "setListInState"
    });
    this.setState({
      loaded: true,
      canDelete: total === 0
    });
  }

  handleClose() {
    if (this.state.touched) {
      noty.confirm(`Are you sure you want to leave? You have unsaved changes.`, {
        onOk: () => this.props.onRequestClose()
      });
    } else {
      this.props.onRequestClose();
    }
  }

  handleSave() {
    const {markerCategory} = this.state;
    const method = markerCategory._id ? "patch" : "create";
    this.setState({fetching: true});
    markerCategory[method]()
      .then(() => {
        method === "patch" ? noty.success("Category updated.") : noty.success("Category created.");
        this.props.onRequestClose();
      })
      .catch(err => {
        noty.errors(err);
        this.setState({fetching: false});
      });
  }

  handleDelete() {
    noty.confirm(`Are you sure you want to delete this category?`, {
      onOk: () => {
        this.setState({fetching: true});
        this.state.markerCategory
          .remove()
          .then(() => {
            noty.success("Category deleted.");
            this.props.onRequestClose();
          })
          .catch(err => {
            noty.errors(err);
            this.setState({fetching: false});
          });
      }
    });
  }

  promptDelete() {
    noty.confirm(
      `You cannot delete this category because there are Marker Types associated with it. Remove all Marker Types from the "${this.state.markerCategory.name}" category before deleting.`,
      {onOk: () => {}, alert: true}
    );
  }

  handleChange({name, value}) {
    const path = name.split(".");
    this.setState({
      touched: true,
      markerCategory: this.state.markerCategory.setIn(path, value)
    });
  }

  render() {
    const {fetching, markerCategory} = this.state;

    return (
      <div>
        <Dialog open maxWidth="sm" fullWidth>
          <DialogTitle>Marker Type Category</DialogTitle>
          <DialogContent>
            <Field
              name="name"
              value={markerCategory.name}
              onChange={this.handleChange}
              label="Marker Type Category Name"
              disabled={fetching}
            />
            <DialogActions>
              <Button color="primary" disabled={fetching} onClick={this.handleClose}>
                Cancel
              </Button>
              <Button color="primary" disabled={fetching} onClick={this.handleSave}>
                Save
              </Button>
              {this.renderDeleteButton()}
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  renderDeleteButton() {
    const {loaded, markerCategory} = this.state;
    if (markerCategory._id && loaded) {
      const {fetching, canDelete} = this.state;
      return (
        <Button
          onClick={canDelete ? this.handleDelete : this.promptDelete}
          style={{float: "left", color: "#999"}}
          disabled={fetching}>
          Delete
        </Button>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/MarkerCategoryModal/index.jsx